const pagesIndividualApprovalTasksEn = {
  columns: {
    applicant: 'Applicant',
    approvalFlow: 'Approval Flow',
    approvalTask: 'Approval Task',
    deadline: 'Deadline',
    status: 'Status',
  },
  empty: 'No approval tasks',
  pageTitle: 'Approval Tasks',
  tabs: {
    all: 'All',
    approved: 'Approved',
    pendingApproval: 'Pending Approval',
    rejected: 'Rejected',
    returned: 'Returned',
  },
};

export default pagesIndividualApprovalTasksEn;
